
import { createI18n } from 'vue-i18n'
import en from '../translation/en.json'
import vi from '../translation/vi.json'

const i18n = createI18n({
	locale: 'vi', // set locale
	fallbackLocale: 'vi', // set fallback locale
	messages: { en, vi }, // set locale messages
});

export default i18n;